import * as go from 'gojs/release/go-module';

import {
  NODE_RESOURCE_SIZE,
  NODE_SIZE,
} from 'src/containers/ProjectDiagram/constants/styles';
import { BaseLinkData } from 'src/containers/ProjectDiagram/types/data';
import { Diagram } from 'src/containers/ProjectDiagram/types/diagram';
import { LinkData, Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isMapping,
  isRelationshipMapping,
} from 'src/containers/ProjectDiagram/utils/data';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const fixUnconnectedLinkPoints =
  (linkData: LinkData) => (model: Model, diagram: Diagram) => {
    if (isRelationshipMapping(linkData)) {
      return;
    }
    const centerPoint = diagram.viewportBounds.center.copy();
    const fromPoint = centerPoint.copy().add(new go.Point(0, -100));
    const toPoint = centerPoint.copy().add(new go.Point(0, 100));

    const fromNode = diagram.findNodeForKey(linkData.from);
    const toNode = diagram.findNodeForKey(linkData.to);
    if (fromNode && toNode) {
      return;
    }

    if (fromNode?.location.isReal()) {
      fromPoint.set(fromNode.location);
      // To offset the link start to touch the node outline and not the center
      // 1. get the angle between the two points
      const degrees = toPoint.directionPoint(fromPoint);
      const radians = degrees * (Math.PI / 180);
      // 2. get the vector for that angle
      const offset = new go.Point(Math.cos(radians), Math.sin(radians));
      // 3. scale the vector by the node size
      const nodeSize = isMapping(linkData) ? NODE_RESOURCE_SIZE : NODE_SIZE;
      offset.scale(nodeSize / 2, nodeSize / 2);
      // 4. subtract the vector from the to point
      fromPoint.subtract(offset);
    }

    if (toNode?.location.isReal()) {
      toPoint.set(toNode.location);
      // To offset the link end to touch the node outline and not the center
      // 1. get the angle between the two points
      const degrees = fromPoint.directionPoint(toPoint);
      const radians = degrees * (Math.PI / 180);
      // 2. get the vector for that angle
      const offset = new go.Point(Math.cos(radians), Math.sin(radians));
      // 3. scale the vector by the node size
      offset.scale(NODE_SIZE / 2, NODE_SIZE / 2);
      // 4. subtract the vector from the to point
      toPoint.subtract(offset);
    }

    const points = [fromPoint.x, fromPoint.y, toPoint.x, toPoint.y];

    setDataProperty<BaseLinkData>(model)(linkData, 'points', points);
  };
